<script>
    import IconMultiCheckbox from '@/components/icon/IconMultiCheckbox.vue';

    export default {
        components: {
            IconMultiCheckbox: IconMultiCheckbox,
        },
        computed: {
            getShowMultiEdit() { return this.$store.getters.IS_SHOW_MULTI_EDIT },
        },
        methods: {
            toggleShowMultiEdit() {
                this.$store.commit('IS_SHOW_MULTI_EDIT', !this.getShowMultiEdit);
            }
        }
    }
</script>


<template>
    <button
        class="left_button_main_container"
        @click="toggleShowMultiEdit"
    >
        <div class="left_button_icon_container">
            <IconMultiCheckbox 
                icon-width="16px"
                icon-height="16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Multi Edit</label>
        </div>
    </button>
</template>